import { render } from "./KeyTermSentiment.vue?vue&type=template&id=4b45ad4f"
import script from "./KeyTermSentiment.vue?vue&type=script&lang=js"
export * from "./KeyTermSentiment.vue?vue&type=script&lang=js"

import "./KeyTermSentiment.vue?vue&type=style&index=0&id=4b45ad4f&lang=css"

import exportComponent from "/Users/noursafadi/Documents/Uni/Parsons-Spring-25/MajorStudio02/MSDV-thesis-2025/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__